import {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

interface BookMenuContextValue {
  activeMenuView: string | null;
  selectMenuView: (viewId: string | null) => void;
}

const BookMenuContext = createContext<BookMenuContextValue>({
  activeMenuView: null,
  selectMenuView: () => {},
});

export function BookMenuContextProvider({
  children,
}: Readonly<PropsWithChildren>) {
  const [activeMenuView, setActiveMenuView] = useState<string | null>(null);

  const selectMenuView = useCallback((viewId: string | null) => {
    setActiveMenuView(viewId);
  }, []);

  const contextValue: BookMenuContextValue = useMemo(
    () => ({
      activeMenuView,
      selectMenuView,
    }),
    [activeMenuView, selectMenuView],
  );

  return (
    <BookMenuContext.Provider value={contextValue}>
      {children}
    </BookMenuContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useBookMenuContext() {
  const context = useContext(BookMenuContext);
  if (context === undefined) {
    throw new Error(
      'useBookMenuContext must be used within a BookMenuContextProvider',
    );
  }
  return context;
}
